import React from "react";
import { GameStyleType } from "./types/types";
import BoardType1 from "./type1/BoardType1";
import BoardType2 from "./type2/BoardType2";
import "../styles/NavigatorСodeBoard.css";

const Board: React.FC<GameStyleType> = (props) => {
  if (props.type === 1) {
    return <BoardType1 {...props} />;
  }
  if (props.type === 2) {
    return <BoardType2 {...props} />;
  }
  return null;
};

export default Board;